module.exports = __webpack_public_path__ + "img/public-btn.d491fcff.png";